export default __webpack_public_path__ + "static/media/ic_apple.fac863ac.svg";